import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";

import React, { useState } from "react";
import { connect } from "react-redux";
import { verifyTrainingRequest } from "../../../store/training/actions";
import { showError } from "../../../app/toastify";
import { Editor, textCapitalizing } from "../../common/components/Utils";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AuthorizationByMinistry from "./AuthorizationByMinistry";
import AuthorizationPermit from "./AuthorizationPermit";
import ErrorMessage from "../../common/components/ErrorMessage";
const VerifyTrainingRequestDialog = (props) => {
  const {
    loading,
    level,
    showVerifyRequest,
    setShowVerifyRequest,
    setShowTrainingRequestDetails,
    request,
    verifyTrainingRequest,
    status,
  } = props;

  const [formData, setFormData] = useState({
    referenceNo: request.referenceNo,
    level: level,
    comments: ``,
    coveredRelatedCostsDetails: request.coveredRelatedCostsDetails,
    draftAuthorizationPermitContent: request.draftAuthorizationPermitContent,
    draftAuthorizationLetterContent: request.draftAuthorizationLetterContent,
  });
  const [errors, setErrors] = useState({
    commentHasError: false,
  });

  const formValidator = () => {
    const error = {
      commentHasError: false,
      hasError: false,
    };

    if (!formData.comments) {
      error.commentHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill out all required fields");
      return true;
    }
    return false;
  };

  const onSave = () => {
    if (!formValidator()) {
      verifyTrainingRequest(formData, setShowTrainingRequestDetails, onClose);
    }
  };

  const onClose = () => {
    setFormData({
      referenceNo: "",
      level: "",
      comments: ``,
    });
    setShowVerifyRequest(false);
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showVerifyRequest}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-primary">
          <Typography variant="overline" display="block">
            REQUEST {level.toUpperCase()} VERIFICATION
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent dividers style={{ maxHeight: "100vh" }}>
          <div className="col-12">
            {request?.statusId === status?.VERIFIED_SENT_TO_MINISTRY_APPROVAL ||
            request?.statusId === status?.REJECTED_BY_MINISTRY ||
            request?.statusId === status?.SENT_TO_MINISTRY_VERIFIER ||
            request?.statusId === status?.NEW ? (
              <AuthorizationByMinistry
                headOfInstitution={{
                  firstName: request?.ministryApproverFirstName,
                  lastName: request?.ministryApproverLastName,
                  title: request?.ministryApproverTitle,

                  institutionName:
                    request?.mifotraApproverInstitutionName || "",
                  positionName: request?.mifotraApproverPositionName || "",
                  canAddInstitutionName:
                    request?.mifotraApproverCanAddInstitutionName || "",
                }}
                employeeTitle={request?.employeeTitle}
                employeeLastName={request?.lastName.toUpperCase()}
                employeeFirstName={textCapitalizing(request?.firstName)}
                positionName={request?.positionName}
                entityName={textCapitalizing(request?.entityName)}
                trainingTitle={textCapitalizing(request?.trainingTitle)}
                universityForTraining={request?.universityForTraining}
                countryForTraining={request?.countryForTraining}
                trainingDurationFrom={request?.trainingDurationFrom}
                trainingDurationTo={request?.trainingDurationTo}
                trainingFundsProvider={request?.coveredRelatedCostsDetails}
                trainingGapsIdentified={request?.trainingGapsIdentified}
                signContent={
                  <table>
                    <tr>
                      <td
                        style={{
                          width: "20%",
                          fontSize: "12px",
                          textAlign: "left",
                          paddingLeft: "6px",
                        }}
                      >
                        <span className="d-block text-danger">Not signed</span>
                      </td>
                      <td
                        style={{
                          width: "20%",
                          fontSize: "12px",
                          textAlign: "left",
                        }}
                      ></td>
                    </tr>
                  </table>
                }
              />
            ) : (
              <>
                <div className="col-12 mt-0">
                  <ReactQuill
                    theme="snow"
                    placeholder="Type your comments..."
                    value={formData.comments || ""}
                    modules={Editor.modules}
                    formats={Editor.formats}
                    onChange={(value) => {
                      const comments = value;
                      setFormData({
                        ...formData,
                        comments,
                      });
                      const commentHasError = false;
                      setErrors({ ...errors, commentHasError });
                    }}
                  />
                  <ErrorMessage
                    hasError={errors.commentHasError}
                    message="A comment is needed."
                  />
                </div>
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions className="d-flex justify-content-center">
          <div className="p-3">
            <div className="row">
              {request?.statusId ===
                status?.VERIFIED_SENT_TO_MINISTRY_APPROVAL ||
                request?.statusId === status?.REJECTED_BY_MINISTRY ||
                request?.statusId === status?.SENT_TO_MINISTRY_VERIFIER ||
                (request?.statusId === status?.NEW && (
                  <div className="col-12 mt-0">
                    <ReactQuill
                      theme="snow"
                      placeholder="Type your comments..."
                      value={formData.comments || ""}
                      modules={Editor.modules}
                      formats={Editor.formats}
                      onChange={(value) => {
                        const comments = value;
                        setFormData({
                          ...formData,
                          comments,
                        });
                        const commentHasError = false;
                        setErrors({ ...errors, commentHasError });
                      }}
                    />
                    <ErrorMessage
                      hasError={errors.commentHasError}
                      message="A comment is needed."
                    />
                  </div>
                ))}

              <div className="col-12 mt-1">
                <button
                  onClick={onSave}
                  type="button"
                  className="btn btn-primary text-uppercase  px-4 float-right"
                  disabled={loading}
                >
                  {loading ? "Wait..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, user }) => {
  return {
    loading,
    user,
  };
};
export default connect(mapStateToProps, {
  verifyTrainingRequest,
})(VerifyTrainingRequestDialog);
